const LEADS_KEY = "ar_whatsapp_leads";
const CLICK_GUARD_MS = 3000;
const CODE_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

let lastLead = null;

function randomCode() {
  let code = "";
  if (window.crypto && window.crypto.getRandomValues) {
    const buf = new Uint32Array(6);
    window.crypto.getRandomValues(buf);
    for (let i = 0; i < 6; i += 1) code += CODE_CHARS[buf[i] % CODE_CHARS.length];
    return code;
  }
  for (let i = 0; i < 6; i += 1) code += CODE_CHARS[Math.floor(Math.random() * CODE_CHARS.length)];
  return code;
}

function dateStamp(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}${m}${day}`;
}

export function getLeads() {
  try {
    const raw = localStorage.getItem(LEADS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function createLead(attribution) {
  const now = Date.now();
  if (lastLead && now - lastLead.createdAtMs < CLICK_GUARD_MS) {
    return lastLead;
  }
  try {
    const leads = getLeads();
    const existingIds = new Set(leads.map((l) => l.leadId));
    let leadId = "";
    do {
      leadId = `AR-${dateStamp()}-${randomCode()}`;
    } while (existingIds.has(leadId));

    const record = {
      leadId,
      createdAt: new Date(now).toISOString(),
      createdAtMs: now,
      source: "whatsapp",
      status: "new",
      gclid: attribution?.gclid || null,
      gbraid: attribution?.gbraid || null,
      wbraid: attribution?.wbraid || null,
    };
    leads.push(record);
    localStorage.setItem(LEADS_KEY, JSON.stringify(leads));
    lastLead = record;
    return record;
  } catch {
    return null;
  }
}
